module.exports = __webpack_public_path__ + "static/media/illy_classico.5d663827.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/illy_classico.png
// module id = 798
// module chunks = 0